module.exports = __webpack_public_path__ + "img/teamfaktor-logo.6851f088.svg";